import React from "react"
import Pagination from "src/components/tailwind-components/Pagination"
import { CreditContractPreparationTableProps } from "../types"
import { CreditContractPreparationTableRow } from "./CreditContractPreparationTableRow"

/**
 * クレジット契約準備作業のテーブル表示コンポーネント。
 * データが存在する場合はテーブルとページネーションを描画する。
 */
export const CreditContractPreparationTable: React.FC<CreditContractPreparationTableProps> = ({
  data,
  pagination,
  isLoading = false,
  onPageChange,
  onStatusUpdate,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">読み込み中...</div>
      </div>
    )
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-gray-500">データがありません</div>
      </div>
    )
  }

  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="min-w-full table-fixed divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="w-[95px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                ユーザーID
              </th>
              <th className="w-[179px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                ユーザー氏名
              </th>
              <th className="w-[142px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                希望着金日
              </th>
              <th className="w-[179px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                加盟店名
              </th>
              <th className="w-[122px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                店舗の定休日
              </th>
              <th className="w-[122px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                審査状況
              </th>
              <th className="w-[137px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                立替申請日
              </th>
              <th className="w-[202px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                メモ
              </th>
              <th className="w-[126px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                担当者
              </th>
              <th className="w-[204px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                最終更新
              </th>
              <th className="w-[142px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                作業ステータス
              </th>
              <th className="w-[220px] px-4 py-8 text-center align-middle text-[14px] font-medium uppercase tracking-wider text-gray-500">
                自動抽出
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item) => (
              <CreditContractPreparationTableRow
                key={item.id}
                item={item}
                onStatusUpdate={onStatusUpdate}
              />
            ))}
          </tbody>
        </table>
      </div>
      <div className="pb-8 pt-4">
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </div>
    </div>
  )
}
